<!-- 兑换码管理：查询列表 + 生成兑换码 -->
<template>
  <div class="exchange-code-page">
    <empty-box class="query-form">
      <a-form-model :model="searchForm" layout="inline" ref="searchForm">
        <a-form-model-item label="兑换码" prop="exchangeCode">
          <a-input v-model="searchForm.exchangeCode" placeholder="请输入兑换码" allowClear />
        </a-form-model-item>
        <a-form-model-item label="设备编号" prop="deviceSerial">
          <a-input v-model="searchForm.deviceSerial" placeholder="请输入设备编号" allowClear />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetQuery">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" icon="plus" @click="openGenerateModal">生成兑换码</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button :disabled="selectedRowKeys.length === 0" @click="exportSelected">导出Excel</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box>

    <div class="table-wrap">
      <a-table
        :columns="columns"
        :data-source="list"
        bordered
        :pagination="false"
        :loading="loading"
        :rowKey="(record) => record.exchangeCode"
        :rowSelection="rowSelection"
        class="table-list"
      >
        <template slot="status" slot-scope="text">
          <a-tag color="green" v-if="Number(text) === 0">未使用</a-tag>
          <a-tag color="orange" v-else>已使用</a-tag>
        </template>
        <span slot="exchangeCode" slot-scope="text, record">
          <span style="margin-right: 8px">{{ text }}</span>
          <a-button type="link" icon="copy" @click="copyText(record.exchangeCode)" style="padding: 0; height: auto;" title="复制兑换码" />
        </span>
        <span slot="createTime" slot-scope="text">{{ formatTime(text) }}</span>
        <span slot="updateTime" slot-scope="text">{{ formatTime(text) }}</span>
        <span slot="detailList" slot-scope="text, record">
          <a-button type="link" @click="openDetailModal(record)">查看</a-button>
        </span>
        <span slot="action" slot-scope="record">
          <a-button v-if="Number(record.status) === 0" type="link" @click="openEditPeriodModal(record)"
            >修改试用时长</a-button
          >
        </span>
      </a-table>

      <pagination
        size="small"
        :hidden="page.total === 0"
        :total="page.total"
        :current.sync="page.current"
        :page-size.sync="page.pageSize"
        @pagination="handlePageChange"
      />
    </div>

    <!-- 生成兑换码弹窗 -->
    <a-modal 
      v-model="generateVisible" 
      title="生成兑换码" 
      :ok-button-props="{ disabled: false }"
      @ok="handleSubmit" 
      @cancel="onReset" 
      width="720px"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        class="generate-form"
      >
        <a-form-model-item label="设备序列号开始" prop="startSerial">
          <a-input v-model="form.startSerial" placeholder="请输入开始序列号" class="w240" />
        </a-form-model-item>
        <a-form-model-item label="设备序列号结束" prop="endSerial">
          <a-input v-model="form.endSerial" placeholder="请输入结束序列号" class="w240" />
        </a-form-model-item>
        <a-form-model-item label="试用时长" prop="periodTime" extra="输入9999表示永久">
          <a-input v-model="form.periodTime" placeholder="请输入试用时长" addon-after="天" class="w240" />
        </a-form-model-item>
        <a-form-model-item label="试用产品" prop="appType">
          <a-select v-model="form.appType" placeholder="请选择试用产品" @change="handleAppTypeChange" class="w240">
            <a-select-option v-for="item in appProductList" :key="item.description">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="试用功能" prop="functionIds">
          <a-select mode="multiple" v-model="form.functionIds" placeholder="请选择试用功能" class="w240">
            <a-select-option v-for="item in functionList" :key="item.functionId">{{ item.functionName }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <div v-if="result" class="gen-result">
          <div class="gen-result__title">本次生成兑换码</div>
          <div class="gen-result__actions">
            <a-button icon="copy" @click="copyGenerated">复制</a-button>
            <a-button style="margin-left: 8px" @click="exportGenerated">导出Excel</a-button>
          </div>
          <div class="gen-result__list">
            <div v-for="item in codeList" :key="item">{{ item }}</div>
          </div>
        </div>
      </a-form-model>
    </a-modal>

    <!-- 兑换码明细弹窗 -->
    <a-modal v-model="detailVisible" title="试用功能" :footer="null" width="900px">
      <a-table
        :columns="detailColumns"
        :data-source="detailList"
        :pagination="false"
        :rowKey="(record, index) => index"
        bordered
      />
    </a-modal>

    <!-- 修改试用时长弹窗 -->
    <a-modal v-model="editPeriodVisible" title="修改试用时长" @ok="submitEditPeriod" width="520px">
      <a-form-model
        ref="editFormRef"
        :model="editForm"
        :rules="editRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="试用时长" prop="periodTime" extra="输入9999表示永久">
          <a-input v-model="editForm.periodTime" addon-after="天" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  addExchangeCode,
  getExchangeCodeUseInfo,
  queryAppProduct,
  querySelectGoodsListByApp,
  updateExchangeCodePeriodTime,
} from '@/api/api'
import Pagination from '@/components/Pagination'
import moment from 'moment'
import * as XLSX from 'xlsx'

const TEL_REG = /^[1-9]\d*$/

export default {
  components: { Pagination },

  computed: {
    codeList() {
      if (!this.result) return []
      return String(this.result).split(',').filter(Boolean)
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },

  data() {
    let validateStartSerial = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入开始序列号'))
      } else if (!TEL_REG.test(value)) {
        callback(new Error('请正确输入设备序列号'))
      } else {
        if (this.form.endSerial !== '') {
          this.$refs.ruleForm.validateField('endSerial')
        }
        callback()
      }
    }

    let validateEndSerial = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入结束序列号'))
      } else if (!TEL_REG.test(value)) {
        callback(new Error('请正确输入设备序列号'))
      } else {
        if (this.form.startSerial && Number(value) < Number(this.form.startSerial)) {
          callback(new Error('结束序列号应大于等于开始序列号'))
        } else {
          callback()
        }
      }
    }

    const columns = [
      // { title: 'ID', dataIndex: 'exchangeId', key: 'exchangeId', align: 'center', width: 150 },
      { title: '设备编号', dataIndex: 'deviceSerial', key: 'deviceSerial', align: 'center' },
      { 
        title: '兑换码', 
        dataIndex: 'exchangeCode', 
        key: 'exchangeCode', 
        align: 'center',
        scopedSlots: { customRender: 'exchangeCode' },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: 110,
        scopedSlots: { customRender: 'status' },
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center',
        width: 180,
        scopedSlots: { customRender: 'createTime' },
      },
      // {
      //   title: '更新时间',
      //   dataIndex: 'updateTime',
      //   key: 'updateTime',
      //   align: 'center',
      //   width: 180,
      //   scopedSlots: { customRender: 'updateTime' },
      // },
      { title: '试用功能信息', key: 'detailList', align: 'center', width: 120, scopedSlots: { customRender: 'detailList' } },
      { title: '操作', key: 'action', align: 'center', width: 150, scopedSlots: { customRender: 'action' } },
    ]

    const detailColumns = [
      // { title: '兑换码明细ID', dataIndex: 'exchangeDetailId', key: 'exchangeDetailId', align: 'center', width: 140 },
      { title: '产品名称', dataIndex: 'productName', key: 'productName', align: 'center' },
      { title: '功能名称', dataIndex: 'functionName', key: 'functionName', align: 'center' },
      { title: '试用时长(天)', dataIndex: 'periodTime', key: 'periodTime', align: 'center', width: 140 },
    ]

    return {
      moment,
      columns,
      detailColumns,

      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },

      searchForm: {
        exchangeCode: '',
        deviceSerial: '',
      },

      list: [],
      selectedRowKeys: [],
      page: {
        current: 1,
        pageSize: 10,
        total: 0,
      },

      generateVisible: false,
      form: {
        startSerial: '',
        endSerial: '',
        periodTime: '',
        appType: undefined,
        functionIds: [],
      },

      appProductList: [],
      functionList: [],

      result: '',

      detailVisible: false,
      detailList: [],

      editPeriodVisible: false,
      editForm: {
        exchangeIds: [],
        periodTime: '',
      },

      rules: {
        startSerial: [{ required: true, validator: validateStartSerial, trigger: 'change' }],
        endSerial: [{ required: true, validator: validateEndSerial, trigger: 'change' }],
        periodTime: [
          { required: true, message: '请输入试用时长', trigger: 'change' },
          { pattern: TEL_REG, message: '请输入正确试用时长', trigger: 'change' },
        ],
        appType: [{ required: true, message: '请选择试用产品', trigger: 'change' }],
        functionIds: [{ required: true, message: '请选择试用功能', trigger: 'change' }],
      },

      editRules: {
        periodTime: [
          { required: true, message: '请输入试用时长', trigger: 'change' },
          { pattern: TEL_REG, message: '请输入正确试用时长', trigger: 'change' },
        ],
      },
    }
  },

  methods: {
    formatTime(t) {
      if (!t) return ''
      return moment(t).format('YYYY-MM-DD HH:mm:ss')
    },

    // 查询
    handleQuery() {
      this.page.current = 1
      this.selectedRowKeys = []
      this.getList()
    },

    // 重置查询
    resetQuery() {
      this.$refs.searchForm && this.$refs.searchForm.resetFields()
      this.page.current = 1
      this.selectedRowKeys = []
      this.getList()
    },

    handlePageChange({ current, pageSize }) {
      this.page.current = current
      this.page.pageSize = pageSize
      // 切换分页时清空选中项
      this.selectedRowKeys = []
      this.getList()
    },

    getList() {
      const para = {
        keys: {
          exchangeCode: this.searchForm.exchangeCode,
          deviceSerial: this.searchForm.deviceSerial,
        },
        page: {
          size: this.page.pageSize,
          current: this.page.current,
        },
      }

      this.loading = true
      getExchangeCodeUseInfo(para)
        .then(({ error, response }) => {
          if (error && error.code !== 0) {
            this.list = []
            this.page.total = 0
            return
          }

          // 按截图：response.records + response.total/size/current
          const records = (response && response.records) || []
          this.list = records
          // 只更新总数，不更新 current 和 pageSize，避免分页被重置
          this.page.total = Number((response && response.total) || 0)
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 获取产品列表
    getAppProduct() {
      const para = { type: 90 }
      queryAppProduct(para).then(({ response }) => {
        this.appProductList = (response && response.products) || []
      })
    },

    // 切换产品
    handleAppTypeChange(e) {
      this.form.functionIds = []
      this.getSelectGoodsListByApp(e)
    },

    // 获取产品试用功能
    getSelectGoodsListByApp(appType) {
      const para = { appType }
      querySelectGoodsListByApp(para).then(({ response }) => {
        this.functionList = (response && response.dataList) || []
      })
    },

    // 复制
    async copyText(text) {
      const value = text == null ? '' : String(text)
      try {
        // 优先使用Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(value)
          this.$message.success('复制成功')
        } else {
          // 降级方案：使用传统方法（兼容旧浏览器）
          const input = document.createElement('textarea')
          input.value = value
          input.style.position = 'fixed'
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
          this.$message.success('复制成功')
        }
      } catch (err) {
        // 如果 Clipboard API 失败，使用降级方案
        try {
          const input = document.createElement('textarea')
          input.value = value
          input.style.position = 'fixed'
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
          this.$message.success('复制成功')
        } catch (fallbackErr) {
          this.$message.error('复制失败，请手动复制')
        }
      }
    },

    copyGenerated() {
      this.copyText(this.codeList.join('\n'))
    },

    // 导出选中的行（xlsx格式）
    exportSelected() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择要导出的数据')
        return
      }

      // 根据选中的 exchangeId 过滤数据
      const selectedData = this.list.filter(item => this.selectedRowKeys.includes(item.exchangeCode))
      if (selectedData.length === 0) {
        this.$message.warning('暂无可导出数据')
        return
      }

      const rows = selectedData.map(item => ({
        设备编号: item.deviceSerial,
        兑换码: item.exchangeCode,
        状态: Number(item.status) === 0 ? '未使用' : '已使用',
        创建时间: this.formatTime(item.createTime),
      }))

      this.downloadAsXlsx(rows, `兑换码列表_${moment().format('YYYYMMDD_HHmmss')}.xlsx`)
    },

    exportGenerated() {
      if (this.codeList.length === 0) {
        this.$message.warning('暂无可导出数据')
        return
      }

      const rows = this.codeList.map(code => ({ 兑换码: code }))
      this.downloadAsXlsx(rows, `兑换码_生成结果_${moment().format('YYYYMMDD_HHmmss')}.xlsx`)
    },

    downloadAsXlsx(rows, filename) {
      if (!rows || rows.length === 0) {
        this.$message.warning('暂无可导出数据')
        return
      }

      // 创建工作簿
      const wb = XLSX.utils.book_new()
      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(rows)
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      // 写入文件
      XLSX.writeFile(wb, filename)
      this.$message.success('导出成功')
    },

    // 生成兑换码
    openGenerateModal() {
      this.generateVisible = true
      this.result = ''
      this.$nextTick(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      })
    },

    handleSubmit(e) {
      // 阻止弹窗自动关闭
      e.preventDefault()
      this.onSubmit()
    },

    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false

        const para = {
          startSerial: this.form.startSerial,
          endSerial: this.form.endSerial,
          periodTime: this.form.periodTime,
          appType: this.form.appType,
          functionIds: this.form.functionIds,
        }

        addExchangeCode(para).then(({ error, response }) => {
          if (error && error.code !== 0) {
            this.$message.error(error.message || '生成失败')
            return
          }
          // 确保 result 是字符串格式
          this.result = response != null ? String(response) : ''
          this.getList()
          this.$message.success('生成成功')
          // 生成成功后清空表单
          this.$nextTick(() => {
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
            this.form.functionIds = []
            this.form.appType = undefined
            this.functionList = []
          })
        }).catch(err => {
          this.$message.error('生成失败：' + (err.message || '未知错误'))
        })
      })
    },

    onReset() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      this.result = ''
      this.generateVisible = false
    },

    // 明细
    openDetailModal(record) {
      this.detailList = (record && record.detailList) || []
      this.detailVisible = true
    },

    // 修改试用时长（仅未使用）
    openEditPeriodModal(record) {
      // 反显当前兑换码的试用时长：从 record.detailList 取
      // 若 detailList 里存在多个不同的 periodTime，则不反显（显示空），避免误改
      const detailList = (record && record.detailList) || []
      const periodTimes = Array.isArray(detailList)
        ? detailList
            .map(d => d && d.periodTime)
            .filter(v => v || v === 0)
            .map(v => String(v))
        : []
      const uniq = Array.from(new Set(periodTimes))
      const periodTime = uniq.length === 1 ? uniq[0] : ''

      this.editForm = { exchangeIds: [record.exchangeId], periodTime }
      this.editPeriodVisible = true
      this.$nextTick(() => {
        // 不用 resetFields（会把刚赋值的 periodTime 清空），只清理校验状态即可
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },

    submitEditPeriod() {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return

        const para = {
          exchangeIds: this.editForm.exchangeIds,
          periodTime: this.editForm.periodTime,
        }

        updateExchangeCodePeriodTime(para).then(({ error }) => {
          if (error && error.code !== 0) return
          this.$message.success('修改成功')
          this.editPeriodVisible = false
          this.getList()
        })
      })
    },
  },

  created() {
    this.getAppProduct()
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.exchange-code-page {
  .table-wrap {
    background: #fff;
  }
}

.generate-form {
  padding-top: 12px;
}

.gen-result {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background: #fafafa;
}

.gen-result__title {
  font-weight: 600;
  margin-bottom: 8px;
}

.gen-result__actions {
  margin-bottom: 8px;
}

.gen-result__list {
  max-height: 260px;
  overflow: auto;
  background: #fff;
  padding: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
</style>
